import React from "react";
import { useSeo } from "../lib/useSeo";
import { PublicPageHeader, PublicPageFooter } from "./PublicPageChrome";

// Shared layout for editorial SEO content (how-to articles + comparison pages).
// Each article supplies its own SEO meta + body JSX; this wraps it in the
// branded chrome, .legal-content styling, and a standard disclaimer/entity
// block so individual articles stay focused on content. Reuses
// PublicPageChrome + useSeo, same pattern as the county guides.

export interface Article {
  seoTitle: string;
  seoDescription: string;
  body: React.ReactNode;
}

const ArticlePage: React.FC<{ article: Article }> = ({ article }) => {
  useSeo({ title: article.seoTitle, description: article.seoDescription });

  return (
    <>
      <PublicPageHeader />
      <div className="legal-page" id="main" tabIndex={-1}>
        <div className="legal-content">
          {article.body}

          <hr className="legal-divider" />
          <p>
            <strong>This is general information, not legal or financial advice.</strong>{" "}
            North Carolina foreclosure rules, amounts, and deadlines change, and every case
            has its own facts. Confirm anything you plan to act on with the county tax
            office, the Clerk of Superior Court, and your own attorney before you bid.
          </p>
          <p className="legal-entity">
            <strong>Parcely LLC</strong>
            <br />
            Charlotte, NC
          </p>
        </div>
      </div>
      <PublicPageFooter />
    </>
  );
};

export default ArticlePage;
